import React, { useState } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ALLOWED_USER } from "../../constants";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { setLoginDetails } from "../../store/auth";
import { Container, Form, Button, InputGroup } from "react-bootstrap";

const AdminLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isEmail, setIsEmail] = useState("");
  const [isPassword, setIsPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validUser = ALLOWED_USER.find(
      (user) => user.email === isEmail && user.password === isPassword
    );

    if (!validUser) {
      toast.error("Invalid email or password!");
      return;
    }

    dispatch(
      setLoginDetails({
        type: validUser.type,
        email: validUser.email,
        isLoggedIn: true,
      })
    );

    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      toast.success("Login successful!");
      navigate("/admin-dashboard");
    }, 2000);
  };

  return (
    <Container className="d-flex justify-content-center align-items-center min-h-100 ">
      <div
        className="p-4 w-100 mx-auto"
        style={{ maxWidth: "400px", backgroundColor: "#fff" }}
      >
        <h4
          className="text-center mb-1 text-dark"
          style={{
            color: "#4a4a4a",
            fontWeight: "600",
            fontFamily: '"Poppins",serif',
          }}
        >
          Welcome Back!
        </h4>

        <p
          className="text-center  mb-4"
          style={{ fontFamily: '"Poppins",serif', color: "#4a4a4b" }}
        >
          Securely sign in to access exclusive content.
        </p>

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="formEmail">
            <Form.Label
              style={{
                color: "#000",
                fontWeight: "500",
                fontFamily: '"Poppins",serif',
              }}
            >
              Email :
            </Form.Label>
            <Form.Control
              required
              type="email"
              value={isEmail}
              placeholder="Enter email"
              onChange={(e) => setIsEmail(e.target.value)}
              style={{
                padding: 12,
                backgroundColor: "#ffffff",
                fontFamily: '"Poppins",serif',
              }}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formPassword">
            <Form.Label
              style={{
                color: "#000",
                fontWeight: "500",
                fontFamily: '"Poppins",serif',
              }}
            >
              Password :
            </Form.Label>
            <InputGroup>
              <Form.Control
                required
                value={isPassword}
                placeholder="Enter password"
                type={showPassword ? "text" : "password"}
                onChange={(e) => setIsPassword(e.target.value)}
                style={{
                  padding: 12,
                  backgroundColor: "#ffffff",
                  fontFamily: '"Poppins",serif',
                }}
              />
              <Button
                variant="outline-secondary"
                onClick={handleTogglePassword}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </Button>
            </InputGroup>
          </Form.Group>

          <Button
            type="submit"
            variant="primary"
            disabled={isLoading}
            className="w-100 mt-4"
            style={{
              padding: 12,
              fontWeight: "600",
              fontFamily: '"Poppins",serif',
              backgroundColor: "#5A67D8",
            }}
          >
            {isLoading ? "Loading..." : "Login"}
          </Button>
        </Form>
      </div>
    </Container>
  );
};

export default AdminLogin;
